let Acupoint = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;

    /**
     * 获取穴位详情数据
     * @param {any} success
     * @param {any} error
     */
    this.Detail = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/Extra/Acupoint/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    /**
     * 获取穴位详情数据
     * @param {any} success
     * @param {any} error
     */
    this.meridianDetail = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/Extra/Meridian/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    /**
     * 获取穴位详情数据
     * @param {any} success
     * @param {any} error
     */
    this.manipulationDetail = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/MassageManipulation/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
}

export { Acupoint }
